import React, { useEffect, useState } from "react";
import Loading from "../../../Extra/Loading";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../Utilitie";
import axios from "axios";
import TableMaster from "../../Milestone/TableMaster";
import OpTransReport from "../../PunctualityFolder/OpTransReports";
const InterChangeEverBest = ({ date, selectedHead }) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [uniqueData, setUniqueData] = useState(new Set());
  const [uniqueData1, setUniqueData1] = useState(new Set());

  const fetchData = async () => {
    setLoading(true);
    let url = `${urlPrefix}getinterchangebestdata?start=${startDate}&end=${endDate}`;
    try {
      const response = await axios.get(url);
      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (data && data?.Data?.length > 0) {
      const yearType = [
        ...new Set(data.Data.map((y) => y.year_type).filter((v) => v != null)),
      ];

      const NAME = [
        ...new Set(data.Data.map((y) => y.NAME).filter((v) => v != null)),
      ];
      const groupedData = {};

      data.Data.forEach((item) => {
        const { NAME, year_type } = item;

        if (!groupedData[NAME]) groupedData[NAME] = {};

        if (!groupedData[NAME][year_type]) groupedData[NAME][year_type] = [];
        groupedData[NAME][year_type].push(item);
      });
      setUniqueData(groupedData);
    }
  }, [data]);

  return (
    <div>
      {/* <div>
        <OpTransReport />
      </div> */}
      <b style={{ color: "red" }}>Under Testing</b>
      Best Ever Master
      <div>
        <div
          className="d-flex justify-content-between  text-white  papaDiv position-relative"
          style={{ background: " rgba(0, 0, 50, 0.6)" }}
        >
          <h5 className=""> </h5>
          <div>
            <div className="d-flex  align-items-center ">
              <b>From </b>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="me-1"
              />

              <b>To </b>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                // className="form-control"
              />
              <button
                className="ms-1 btn btn-sm btn-outline-light"
                onClick={fetchData}
              >
                Fetch
              </button>
            </div>
          </div>
        </div>

        {loading && <Loading />}

        <div className="  row d-flex" style={{ overflowY: "auto" }}>
          {Object.keys(uniqueData).map((nameKey) => {
            if (nameKey !== selectedHead) return null;

            return (
              <div
                key={nameKey}
                className="mb-5 p-2 rounded col-5 newUiBody"
                style={{ background: "rgba(239, 245, 248, 0.6)" }}
              >
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <h4
                    className="text-white rounded px-4 py-2 mb-0 shadow-sm"
                    style={{
                      background: "rgba(0, 0, 50, 0.6)",
                      fontSize: "18px",
                    }}
                  >
                    {nameKey.replace("_", " ")}
                  </h4>
                </div>

                <div className="d-flex flex-nowrap overflow-auto px-2">
                  {Object.keys(uniqueData[nameKey])
                    .sort(
                      (a, b) =>
                        ["CURRENT", "MONTHLY_TOP3", "YEARLY_TOTAL"].indexOf(a) -
                        ["CURRENT", "MONTHLY_TOP3", "YEARLY_TOTAL"].indexOf(b),
                    )
                    .map((yearKey) => (
                      <div key={yearKey} className="p-1 d-flex">
                        <TableMaster
                          data={uniqueData[nameKey][yearKey]}
                          yearType={yearKey}
                        />
                      </div>
                    ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="ro "></div>
      </div>
    </div>
  );
};
export default InterChangeEverBest;
